import { useQuery } from '@tanstack/react-query';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

import Api from '@barboxx/api';
import { PriceTier } from '@barboxx/models/types';

interface Props {
    disabled?: boolean;
}

interface PriceTierWatchProps {
    priceTier: PriceTier | null;
}

export function PriceTierInput({ disabled = false }: Props) {
    const { priceTier } = useFormContext<PriceTierWatchProps>().getValues();
    const priceTierQueryResult = useQuery({
        queryKey: ['priceTiers'],
        queryFn: () =>
            Api.Core.PriceTier.getPriceTiers({
                page: 0,
                size: 1000,
                sort: 'name,asc',
            }),
        initialData: {
            ok: true,
            problem: null,
            originalError: null,
            data: {
                results: priceTier ? [priceTier] : [],
                total: 1,
                isPaginated: false,
            },
        },
    });

    return (
        <AutocompleteElement
            label="Price Tier"
            name="priceTierId"
            loading={priceTierQueryResult.isLoading}
            multiple={false}
            options={priceTierQueryResult.data?.data?.results ?? []}
            transform={{
                output(event, value, reason, details) {
                    if (reason === 'selectOption') {
                        return typeof value === 'string' ? value : value?.id;
                    }
                    if (reason === 'removeOption') {
                        return null;
                    }
                    return value;
                },
            }}
            autocompleteProps={{
                fullWidth: true,
                readOnly: disabled,
                disabled: disabled,
                isOptionEqualToValue(
                    option?: PriceTier,
                    value?: PriceTier | number | null
                ) {
                    const isNumber = typeof value === 'number';

                    if (isNumber) {
                        return option?.id === value;
                    } else {
                        return option?.id === (value?.id ?? value);
                    }
                },
                getOptionLabel(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.name}`;
                },
            }}
        />
    );
}
